/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/sf9-featured-emersya-products.js
  var require_sf9_featured_emersya_products = __commonJS({
    "src/js/sf9-featured-emersya-products.js"(exports) {
      (() => {
        const sections = Array.from(document.querySelectorAll(".featured-emersya-products"));
        sections.forEach((section) => __async(null, null, function* () {
          const customerId = section.dataset.customerId;
          const collectionId = section.dataset.collectionId;
          const listEl = section.querySelector(".featured-emersya-products__list");
          if (!(customerId && collectionId && listEl)) return;
          section.removeAttribute("data-customer-id");
          section.removeAttribute("data-collection-id");
          const res = yield fetch(`${window.theme.settings.orchestraHost}/event-eco/product/list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              collectionId,
              "3d": true
            })
          });
          if (!res.ok) {
            section.remove();
            return;
          }
          const resData = yield res.json();
          const products = resData.data;
          if (!(products == null ? void 0 : products.length)) {
            section.remove();
            return;
          }
          let productsMarkup = "";
          const tierIndices = ["Essential", "Xtra", "Premium", "Outstanding"];
          const groupedProducts = {};
          const nonGroupedProducts = [];
          products.forEach((product) => {
            const tierIndice = tierIndices.indexOf(product.package);
            const ogProductName = product.name.replace("Essential", "").replace("Xtra", "").replace("Premium", "").replace("Outstanding", "");
            if (tierIndice < 0) {
              nonGroupedProducts.push(product);
              return;
            }
            if (!groupedProducts[ogProductName]) groupedProducts[ogProductName] = [];
            groupedProducts[ogProductName][tierIndice] = product;
          });
          const orderedGroupedProducts = Object.entries(groupedProducts).sort((a, b) => {
            const dimensionsA = extractDimensions(a[0]);
            const dimensionsB = extractDimensions(b[0]);
            if (!dimensionsA) return -1;
            if (!dimensionsB) return 1;
            if (dimensionsA[0] !== dimensionsB[0]) {
              return dimensionsA[0] - dimensionsB[0];
            }
            return dimensionsA[1] - dimensionsB[1];
          }).map(([ogProductName, products2]) => products2);
          [...orderedGroupedProducts, nonGroupedProducts].forEach((products2) => {
            products2.forEach((product) => {
              var _a;
              if (!product) return;
              productsMarkup += `
					<a href="/products/${product.handle}" class="featured-emersya-products__product">
						<div class="fep__product-top">
							<div class="fep__product-title">${product.package || product.name}</div>
							<div class="fep__product-price">
								<span>from</span><strong> ${formatPrice(product.price)} </strong><span>ex. VAT</span>
							</div>
							<div class="fep__product-visit-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="5" fill="none"/></svg>
							</div>
						</div>
						<div class="fep__product-image">
							${product.image ? `<img src="${product.image}" />` : ""}
						</div>
						${product.packageDetails ? `<div class="fep__product-details">
								<strong>Includes:</strong>
								<ul>
									${(_a = product.packageDetails) == null ? void 0 : _a.split("\n").map(
                (detail) => `
											<li>${detail}</li>
										`
              ).join("")}
								</ul>
							</div>` : ""}
					</a>
				`;
            });
          });
          listEl.innerHTML = productsMarkup;
        }));
        function extractDimensions(productName) {
          const match = productName.match(/(\d+(?:\.\d+)?)\s*m?\s*x\s*(\d+(?:\.\d+)?)\s*m?/i);
          if (!match) return null;
          return [parseFloat(match[1]), parseFloat(match[2])];
        }
        __name(extractDimensions, "extractDimensions");
        function formatPrice(amount) {
          let asString = String(amount);
          let decimalSeparator = asString.includes(".") ? "." : ",";
          let integerSeparator = decimalSeparator === "." ? "," : ".";
          let decimals = asString.split(decimalSeparator)[1];
          let integer = asString.split(decimalSeparator)[0];
          if (!decimals || decimals === "0" || decimals === "00") decimals = "";
          let integerDigitsReversed = integer.split("").reverse();
          let formattedInteger = integerDigitsReversed.map((digit, idx) => `${digit}${idx !== 0 && idx % 3 === 0 ? integerSeparator : ""}`).reverse().join("");
          let formattedPrice = `\u20AC${formattedInteger}${decimals ? `${decimalSeparator}${decimals}` : ""}`;
          return formattedPrice;
        }
        __name(formatPrice, "formatPrice");
      })();
    }
  });
  require_sf9_featured_emersya_products();
})();
